import Head from 'expo-router/head';

import SignoutPage from '@fhs-legacy/frontend/src/pages/authentication/sign-out';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function SignOutRoute() {
  return (
    <>
      <Head>
        <title>Sign Out - Firehouse Subs</title>
      </Head>
      <SignoutPage />
    </>
  );
}
